module.exports = __webpack_public_path__ + "common/search/icon-unisex-30066b75ec6889a1e5bf8855814350d9.svg";